import React from 'react';
import { Body } from '@routific/hive';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../../store/mst';
import PublishButton, { PublishButtonType } from '../../RouteActionButtons/PublishButton';

interface Props {}

const RouteDetailsPanelFooter: React.FC<Props> = () => {
  const store = useStore();
  const { selectedRoute } = store.ui;
  const { t } = useTranslation(['common', 'components']);

  return (
    <>
      <div>
        {!!selectedRoute?.isBeingModified && !selectedRoute.isLocked && <Body loading type="secondary">{t('common:loading.recalculating')}</Body>}
      </div>
      <PublishButton
        selectedRouteUuids={selectedRoute?.uuid ? [selectedRoute.uuid] : []}
        buttonType={PublishButtonType.DETAIL}
      />
    </>
  );
};

export default observer(RouteDetailsPanelFooter);
